import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Row, Select, Button, Alert } from 'antd';
import { usePolicyOptions, useOptionsDropDown, useRequestValidate, useBankCode } from 'all-in-one-shared-api';
import { Spinner } from 'components';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
// import { Attachments } from 'types';
import styled from 'styled-components';
import GreetingSection from 'components/navbar/GreetingSection';
import './PolicyOptionsStyle.less';
import { PolicyOptionsCard } from './components/PolicyOptionsCard';
import { PaymenttactCardno } from './components/PolicyOptionsCardno';
import { ChangePolicyOptionsCard } from './components/ChangePolicyOptionsCard';
import edit from 'assets/images/MakeRequest/edit.svg';
import editdisabled from 'assets/images/MakeRequest/editdisabled.svg';
import { PolicyOptionsFormData } from './utiles/PolicyOptionsFormData';
// import { setErrorCodeFun } from './utile/setErrorCodeFun';
import generateKey from 'utils/generateKey';
import { AgreementCard2 } from './components/Agreement/AgreementCard2';
import { PaymentConfrimCard } from './components/PolicyOptionsConfirmCard';
import { useNavigate } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
import { DocumentsCard } from './components/DocumentsCard';
import { Attachments } from 'types';
import { revalidateAntdFormLanguageChanged } from 'i18n';
import { FieldChange } from './utiles/PolicyOptionsFormData';
// import { useNavigate } from 'react-router-dom';

//内容部分布局
const EnquiryPageContainer = styled.div`
  margin: 0;
`;
interface commonListProps {
  label: string;
  labelTc: string;
  value: string;
  code: string;
}
// const dividendList = [
//   { label: 'Cash Payment', labelTc: '支取現金', value: 'Cash Payment' },
//   { label: 'Accumulate with interest', labelTc: '積存生息', value: 'Accumulate with interest' },
//   { label: 'Paid Up Additions', labelTc: '購買繳費保險', value: 'Paid Up Additions' },
// ];
// const paymentOptionList = [
//   { label: 'Cash Payment', labelTc: '支取現金', value: 'Cash Payment' },
//   { label: 'Accumulate with interest', labelTc: '積存生息', value: 'Accumulate with interest' },
// ];
// const paymentMethodList = [
//   {
//     label: 'Credit to Policyholder’s local bank account in Hong Kong currency',
//     labelTc: '以港幣存入保單持有人的本地銀行賬戶',
//     value: 'Credit to Policyholder’s local bank account in Hong Kong currency',
//   },
//   { label: 'Cheque', labelTc: '現金', value: 'Cheque' },
// ];
// const chequeCurrencyList = [
//   { label: 'USD', labelTc: '美金', value: 'USD' },
//   { label: 'HKD', labelTc: '港幣', value: 'HKD' },
// ];
//页面
function ChangePolicyOptions() {
  //定义变量
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const navigate = useNavigate();
  const [documentInvalid, setDocumentInvalid] = useState<boolean>(false);
  const [form] = Form.useForm<PolicyOptionsFormData>();
  // const methods = useForm();
  const [isAgreed, setIsAgreed] = useState(false);
  const [key, setKey] = useState<string>('cahduashdiagdia');
  const [companyCode, setCompanyCode] = useState('');
  const [policyNumber, setPolicyNumber] = useState<string>('');
  const [startLoading, setStartLoading] = useState<boolean>(true);
  const [EditCode, setEditCode] = useState<boolean>(false); //edit的顯隱
  const [EditDisable, setEditDisable] = useState<boolean>(false); //edit置灰
  const [aftersub, setaftersub] = useState<boolean>(false);
  const [Errmessage, setErrmessage] = useState<string>('');
  // const [diviAccountNo, setDiviAccountNo] = useState('');
  // const [paymentAccountNo, setPaymentAccountNo] = useState('');
  const [filesFlag, setFilesFlag] = useState<boolean>(false);
  const [dividendOptionsList, setdividendOptionsList] = useState<commonListProps[]>([]);
  const [paymentOptionsList, setPaymentOptionsList] = useState<commonListProps[]>([]);
  const [paymentMethodList, setPaymentMethodList] = useState<commonListProps[]>([]);
  const [annPaymentMethodList, setAnnPaymentMethodList] = useState<commonListProps[]>([]);
  const [chequeList, setChequeList] = useState<commonListProps[]>([]);
  const [divPMName, setDivPMName] = useState('');
  const [payPMName, setPayPMName] = useState('');
  const [diviName, setDiviName] = useState('');
  const [payName, setPayName] = useState('');
  // const [requestData, setrequestData] = useState<ContactFormData>();
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { policyNo } = (location.state as LocationState) ?? {};
  const childRef = useRef<{ getOriginValue: () => string; getOriginValue2: () => string }>(null);
  const { token } = useKeycloakReady();
  // const {
  //   shouldFetch: shouldFecthResquestDrop,
  //   data: RequestdropData,
  //   error: requestError,
  // } = useOptionsDropDown('useOptionsDropDown', token || '', companyCode);
  const {
    shouldFetch: shouldFecthDrop,
    data: dropData,
    error: requestError,
    // isLoading: dropDataisLoading,
  } = useOptionsDropDown('useOptionsDropDown', token || '');
  const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  useEffect(() => {
    shouldFecthDrop(true);
  }, [shouldFecthDrop]);
  useEffect(() => {
    // setStartLoading(true);
    if (requestError?.code && requestError?.message) {
      navigate('/ChangeRequestErrorpage', {
        replace: true,
      });
    }
  }, [requestError, shouldFecthDrop, navigate]);
  dropData?.map((item) => {
    policyTypesObject.push({
      label: i18n.language == 'en' ? item.productName : item.productNameTC,
      label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
      value: item.policyNumber,
    });
  });

  const {
    data: PolicyOptionsInformation,
    shouldFetch: ContactInformationShouldFetch,
    error: PolicyOptionsError,
  } = usePolicyOptions(key, token || '', policyNumber, companyCode, {});
  useEffect(() => {
    if (dropData) {
      setStartLoading(false);
    }
    if (policyNumber && companyCode) {
      console.log('policyNumber', policyNumber, 'companyCode', companyCode);
      setKey(generateKey());
      setStartLoading(true);
      ContactInformationShouldFetch(true);
    }
    // if (policyNo && policyNumber == '') {
    //   const code = RequestdropData?.find((item) => item.policyNumber == policyNo)?.companyCode;
    //   if (code) {
    //
    //     setCompanyCode(code);
    //     setPolicyNumber(policyNo);
    //     ContactInformationShouldFetch(true);
    //   }
    // }
  }, [ContactInformationShouldFetch, setStartLoading, policyNumber, dropData, companyCode]);
  // useEffect(() => {
  //   if (key) {

  //   }
  // }, [key, ContactInformationShouldFetch]); // 当 key 更新时触发

  // useEffect(() => {
  //   // setKey(generateKey());
  //   // setCompanyCode('2');
  //   shouldFecthResquestDrop(true);
  //   // ContactInformationShouldFetch(true);
  // }, [companyCode, shouldFecthResquestDrop]);
  useEffect(() => {
    if (PolicyOptionsInformation && !PolicyOptionsError) {
      setStartLoading(false);
      form.setFieldsValue({
        dividendOptions: PolicyOptionsInformation?.dividendOptions ?? '',
        dividendOptionsOld: PolicyOptionsInformation?.dividendOptions ?? '',
        dividendOptionsCode:
          PolicyOptionsInformation?.dividendOptionsCode == '' ? null : PolicyOptionsInformation?.dividendOptionsCode,
        dividendOptionsCashPaymentMethod:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethod == ''
            ? null
            : PolicyOptionsInformation?.dividendOptionsCashPaymentMethod,
        dividendOptionsCashPaymentMethodCode: PolicyOptionsInformation?.dividendOptionsCashPaymentMethodCode,
        dividendOptionsCashPaymentMethodOld:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethod == ''
            ? null
            : PolicyOptionsInformation?.dividendOptionsCashPaymentMethod,
        dividendOptionsCashPaymentMethodCheque:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodCheque == ''
            ? null
            : PolicyOptionsInformation?.dividendOptionsCashPaymentMethodCheque,
        dividendOptionsCashPaymentMethodChequeOld:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodCheque == ''
            ? null
            : PolicyOptionsInformation?.dividendOptionsCashPaymentMethodCheque,
        dividendOptionsCashPaymentMethodBankCode:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBankCode == ''
            ? null
            : PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBankCode,
        dividendOptionsCashPaymentMethodBranchNo:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBranchNo ?? '',
        dividendOptionsCashPaymentMethodAccountNo:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodAccountNo ?? '',
        dividendOptionsCashPaymentMethodHolderName:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodHolderName,
        dividendOptionsCashPaymentMethodBankCodeOld:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBankCode == ''
            ? null
            : PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBankCode,
        dividendOptionsCashPaymentMethodBranchNoOld:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBranchNo ?? '',
        dividendOptionsCashPaymentMethodAccountNoOld:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodAccountNo ?? '',
        dividendOptionsCashPaymentMethodHolderNameOld:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodHolderName,
        paymentOptions: PolicyOptionsInformation?.paymentOptions ?? '',
        paymentOptionsOld: PolicyOptionsInformation?.paymentOptions ?? '',
        paymentOptionsCode:
          PolicyOptionsInformation?.paymentOptionsCode == '' ? null : PolicyOptionsInformation?.paymentOptionsCode,
        paymentOptionsCashPaymentMethod:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethod == ''
            ? null
            : PolicyOptionsInformation?.paymentOptionsCashPaymentMethod,
        paymentOptionsCashPaymentMethodOld:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethod == ''
            ? null
            : PolicyOptionsInformation?.paymentOptionsCashPaymentMethod,
        paymentOptionsCashPaymentMethodCode: PolicyOptionsInformation?.paymentOptionsCashPaymentMethodCode,
        paymentOptionsCashPaymentMethodCheque:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodCheque == ''
            ? null
            : PolicyOptionsInformation?.paymentOptionsCashPaymentMethodCheque,
        paymentOptionsCashPaymentMethodChequeOld:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodCheque == ''
            ? null
            : PolicyOptionsInformation?.paymentOptionsCashPaymentMethodCheque,
        paymentOptionsCashPaymentMethodBankCodeOld:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBankCode == ''
            ? null
            : PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBankCode,
        paymentOptionsCashPaymentMethodBranchNoOld:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBranchNo ?? '',
        paymentOptionsCashPaymentMethodAccountNoOld:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodAccountNo ?? '',
        paymentOptionsCashPaymentMethodHolderNameOld:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodHolderName,
        paymentOptionsCashPaymentMethodBankCode:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBankCode == ''
            ? null
            : PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBankCode,
        paymentOptionsCashPaymentMethodBranchNo:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBranchNo ?? '',
        paymentOptionsCashPaymentMethodAccountNo:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodAccountNo ?? '',
        paymentOptionsCashPaymentMethodHolderName: PolicyOptionsInformation?.paymentOptionsCashPaymentMethodHolderName,
        dividendOptionsFlag: PolicyOptionsInformation?.dividendOptionsFlag ?? 'N',
        dividendOptionsCashPaymentMethodFlag: PolicyOptionsInformation?.dividendOptionsCashPaymentMethodFlag ?? 'N',
        dividendOptionsChequeFlag: PolicyOptionsInformation?.dividendOptionsChequeFlag ?? 'N',
        dividendOptionsCashPaymentMethodBankCodeFlag:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBankCodeFlag ?? 'N',
        dividendOptionsCashPaymentMethodBranchNoFlag:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodBranchNoFlag ?? 'N',
        dividendOptionsCashPaymentMethodAccountNoFlag:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodAccountNoFlag ?? 'N',
        dividendOptionsCashPaymentMethodHolderNameFlag:
          PolicyOptionsInformation?.dividendOptionsCashPaymentMethodHolderNameFlag ?? 'N',
        paymentOptionsFlag: PolicyOptionsInformation?.paymentOptionsFlag ?? 'N',
        paymentOptionsCashPaymentMethodFlag: PolicyOptionsInformation?.paymentOptionsCashPaymentMethodFlag ?? 'N',
        paymentOptionsChequeFlag: PolicyOptionsInformation?.paymentOptionsChequeFlag ?? 'N',
        paymentOptionsCashPaymentMethodBankCodeFlag:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBankCodeFlag ?? 'N',
        paymentOptionsCashPaymentMethodBranchNoFlag:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodBranchNoFlag ?? 'N',
        paymentOptionsCashPaymentMethodAccountNoFlag:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodAccountNoFlag ?? 'N',
        paymentOptionsCashPaymentMethodHolderNameFlag:
          PolicyOptionsInformation?.paymentOptionsCashPaymentMethodHolderNameFlag ?? 'N',
      });
      const dividendList =
        PolicyOptionsInformation.dividendOptionsAll.length > 0
          ? PolicyOptionsInformation.dividendOptionsAll.map((i) => {
              return {
                label: i.dividendOptionDesc,
                labelTc: i.dividendOptionDescTc,
                value: i.dividendOptionDesc,
                code: i.dividendOptionCode,
              };
            })
          : [];
      const paymentList =
        PolicyOptionsInformation.paymentOptionsAll.length > 0
          ? PolicyOptionsInformation.paymentOptionsAll.map((i) => {
              return {
                label: i.paymentOptionDesc,
                labelTc: i.paymentOptionDescTc,
                value: i.paymentOptionDesc,
                code: i.paymentOptionCode,
              };
            })
          : [];
      const paymentMethodList =
        PolicyOptionsInformation.paymentMethodList.length > 0
          ? PolicyOptionsInformation.paymentMethodList.map((i) => {
              return {
                label: i.paymentMethodEn,
                labelTc: i.paymentMethodTc,
                value: i.paymentMethodEn,
                code: i.paymentMethodCode,
              };
            })
          : [];
      const annPaymentMethodList =
        PolicyOptionsInformation.annPaymentMethodList.length > 0
          ? PolicyOptionsInformation.annPaymentMethodList.map((i) => {
              return {
                label: i.paymentMethodEn,
                labelTc: i.paymentMethodTc,
                value: i.paymentMethodEn,
                code: i.paymentMethodCode,
              };
            })
          : [];
      const chequeList =
        PolicyOptionsInformation.chequeCurrencyList.length > 0
          ? PolicyOptionsInformation.chequeCurrencyList.map((i) => {
              return {
                label: i.chequeEn,
                labelTc: i.chequeTc,
                value: i.chequeEn,
                code: i.chequeCode,
              };
            })
          : [];
      setdividendOptionsList(dividendList);
      setPaymentOptionsList(paymentList);
      setPaymentMethodList(paymentMethodList);
      setAnnPaymentMethodList(annPaymentMethodList);
      setChequeList(chequeList);
    }
    // if (ContactInformationError) {
    // }
    // const dividendList = PolicyOptionsInformation.dividendOptionsAll.map((item, index) => {
    //   return {
    //     label: item,
    //     labelTc: PolicyOptionsInformation.dividendOptionsAllTc[index],
    //     value: item,
    //   };
    // });
    // const paymentOptionList = PolicyOptionsInformation.paymentOptionsAll.map((item,index) => {
    //   return {
    //     label: item,
    //     labelTc: PolicyOptionsInformation.paymentOptionsAllTc[index],
    //     value: item,
    //   };
    // });

    if (PolicyOptionsError) {
      // setStartLoading(false);
    }
    // eslint-disable-next-line
  }, [PolicyOptionsInformation, PolicyOptionsError, form]);

  useEffect(() => {
    if (PolicyOptionsInformation) {
      if (
        PolicyOptionsInformation.changeStatusCode == 'Processing' ||
        PolicyOptionsInformation.changeStatusCode == 'Assignment' ||
        PolicyOptionsInformation.changeStatusCode == 'DisableEditing'
      ) {
        setEditDisable(true);
      }
      const mess =
        i18n.language == 'en' ? PolicyOptionsInformation.changeStatusDesc : PolicyOptionsInformation.changeStatusDescTc;
      setErrmessage(mess ?? '');
      //将== TT的情况所涉及到的值（原值和old值）单独提出来收到语言的监听，且只有此时值有中英文之分
      if (PolicyOptionsInformation.dividendOptionsCashPaymentMethodCode == 'TT') {
        setDivPMName(
          i18n.language == 'en'
            ? PolicyOptionsInformation.dividendOptionsCashPaymentMethod
            : PolicyOptionsInformation.dividendOptionsCashPaymentMethodTc,
        );
        form.setFieldsValue({
          dividendOptionsCashPaymentMethod:
            i18n.language == 'en'
              ? PolicyOptionsInformation.dividendOptionsCashPaymentMethod
              : PolicyOptionsInformation.dividendOptionsCashPaymentMethodTc,
          dividendOptionsCashPaymentMethodOld:
            i18n.language == 'en'
              ? PolicyOptionsInformation.dividendOptionsCashPaymentMethod
              : PolicyOptionsInformation.dividendOptionsCashPaymentMethodTc,
        });
      }
      if (PolicyOptionsInformation.paymentOptionsCashPaymentMethodCode == 'TT') {
        setPayPMName(
          i18n.language == 'en'
            ? PolicyOptionsInformation.paymentOptionsCashPaymentMethod
            : PolicyOptionsInformation.paymentOptionsCashPaymentMethodTc,
        );
        form.setFieldsValue({
          paymentOptionsCashPaymentMethod:
            i18n.language == 'en'
              ? PolicyOptionsInformation.paymentOptionsCashPaymentMethod
              : PolicyOptionsInformation.paymentOptionsCashPaymentMethodTc,
          paymentOptionsCashPaymentMethodOld:
            i18n.language == 'en'
              ? PolicyOptionsInformation.paymentOptionsCashPaymentMethod
              : PolicyOptionsInformation.paymentOptionsCashPaymentMethodTc,
        });
      }
      setDiviName(
        i18n.language == 'en' ? PolicyOptionsInformation.dividendOptions : PolicyOptionsInformation.dividendOptionsTc,
      );
      setPayName(
        i18n.language == 'en' ? PolicyOptionsInformation.paymentOptions : PolicyOptionsInformation.paymentOptionsTc,
      );
    }
    //eslint-disable-next-line
  }, [i18n.language, PolicyOptionsInformation]);

  const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');
  useEffect(() => {
    shouldFetchBankList(true);
  }, [shouldFetchBankList]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const myBankList: { label: string; value: string; chineseDescription: string; description: string }[] = [];
  bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
    myBankList.push({
      label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
      value: item.bankCode,
      chineseDescription: item.bankNameTc,
      description: item.bankName,
    });
  });
  const PnChange = (e: string) => {
    setPolicyNumber(e);
    setKey(generateKey());
    setStartLoading(true);
    // if (EditCode) {
    setaftersub(false);
    setEditDisable(false);
    setEditCode(false);
    setErrorMessage(''); //初始化
    setErrmessage('');
    console.log('eeeeeee', e);
    console.log('policyNumber', policyNumber);
    const code = dropData?.find((item) => item.policyNumber == e)?.companyCode;
    if (code) {
      console.log('code', code);
      setCompanyCode(code);
    }
    // }
    // else {
    //   console.log('eeeeeee', e);
    //   setPolicyNumber(e);
    //   const code = dropData?.find((item) => item.policyNumber == e)?.companyCode;
    //   if (code) {
    //     setCompanyCode(code);
    //   }
    // }
  };
  const Edit = () => {
    if (!EditDisable) {
      setEditCode(true);
    }
  };
  const onSubmit = (values: PolicyOptionsFormData) => {
    setErrorMessage('');
    console.log('values-----------------------------', values);
    console.log('formData-----------------------------', form.getFieldsValue(true));
    // if (childRef.current) {
    //   setDiviAccountNo(childRef.current.getOriginValue() ?? '');
    //   setPaymentAccountNo(childRef.current.getOriginValue2() ?? '');
    // }

    // if (
    //   (form.getFieldValue('paymentOptionsCashPaymentMethodCode') == 'DC' &&
    //     // form.getFieldValue('paymentOptionsCashPaymentMethod') !==
    //     //   form.getFieldValue('paymentOptionsCashPaymentMethodOld') &&
    //     form.getFieldValue('paymentOptionsCode') == 'CASHPAYS') ||
    //   (form.getFieldValue('dividendOptionsCashPaymentMethodCode') == 'DC' &&
    //     // form.getFieldValue('dividendOptionsCashPaymentMethod') !==
    //     //   form.getFieldValue('dividendOptionsCashPaymentMethod') &&
    //     form.getFieldValue('dividendOptionsCode') == 'CASHPAYS')
    // ) {
    //   setFilesFlag(true);
    // } else {
    //   setFilesFlag(false);
    // }
    if (isChangeList(form.getFieldsValue(true)).length > 0) {
      const value1 = isChangeList(form.getFieldsValue(true)).find(
        (i) => i.key == 'dividendOptionsCashPaymentMethod',
      )?.changedValue;
      const value2 = isChangeList(form.getFieldsValue(true)).find(
        (i) => i.key == 'paymentOptionsCashPaymentMethod',
      )?.changedValue;
      if (
        value1 == paymentMethodList.find((i) => i.code == 'DC')?.value ||
        value2 == annPaymentMethodList.find((i) => i.code == 'DC')?.value
      ) {
        setFilesFlag(true);
      } else {
        setFilesFlag(false);
      }
      shouldValidateFetch(true);
    } else {
      setErrorMessage('xapi.policy.no.change.request');
    }
  };
  const paANo = 'paymentOptionsCashPaymentMethodAccountNo';
  const diBNo = 'dividendOptionsCashPaymentMethodBranchNo';
  const diBCo = 'dividendOptionsCashPaymentMethodBankCode';
  const isChangeList = (data: PolicyOptionsFormData) => {
    const changeList = [];
    if (data.dividendOptionsCode == 'CASHPAYS') {
      if (data.dividendOptionsCashPaymentMethodCode == 'CQ') {
        if (
          data.dividendOptions != data.dividendOptionsOld ||
          data.dividendOptionsCashPaymentMethod != data.dividendOptionsCashPaymentMethodOld ||
          data.dividendOptionsCashPaymentMethodCheque != data.dividendOptionsCashPaymentMethodChequeOld
        ) {
          changeList.push({
            key: 'dividendOptions',
            changedValue: [data.dividendOptions],
            originalValue: [data.dividendOptionsOld],
          });
          changeList.push({
            key: 'dividendOptionsCashPaymentMethod',
            changedValue: [data.dividendOptionsCashPaymentMethod],
            originalValue: [data.dividendOptionsCashPaymentMethodOld],
          });
          changeList.push({
            key: 'dividendOptionsCashPaymentMethodCheque',
            changedValue: [data.dividendOptionsCashPaymentMethodCheque],
            originalValue: [data.dividendOptionsCashPaymentMethodChequeOld],
          });
        }
      } else {
        if (
          data.dividendOptions != data.dividendOptionsOld ||
          data.dividendOptionsCashPaymentMethod != data.dividendOptionsCashPaymentMethodOld ||
          data.dividendOptionsCashPaymentMethodBankCode != data.dividendOptionsCashPaymentMethodBankCodeOld ||
          data.dividendOptionsCashPaymentMethodBranchNo != data.dividendOptionsCashPaymentMethodBranchNoOld ||
          data.dividendOptionsCashPaymentMethodAccountNo != data.dividendOptionsCashPaymentMethodAccountNoOld ||
          data.dividendOptionsCashPaymentMethodHolderName != data.dividendOptionsCashPaymentMethodHolderNameOld
        ) {
          changeList.push({
            key: 'dividendOptions',
            changedValue: [data.dividendOptions],
            originalValue: [data.dividendOptionsOld],
          });
          changeList.push({
            key: 'dividendOptionsCashPaymentMethod',
            changedValue: [data.dividendOptionsCashPaymentMethod],
            originalValue: [data.dividendOptionsCashPaymentMethodOld],
          });
          changeList.push({
            key: diBCo,
            changedValue: [
              data.dividendOptionsCashPaymentMethodBankCode +
                '-' +
                myBankList?.find((item) => item.value === data.dividendOptionsCashPaymentMethodBankCode)?.description,
            ],
            originalValue: [data.dividendOptionsCashPaymentMethodBankCodeOld],
          });
          changeList.push({
            key: diBNo,
            changedValue: [data.dividendOptionsCashPaymentMethodBranchNo],
            originalValue: [data.dividendOptionsCashPaymentMethodBranchNoOld],
          });
          changeList.push({
            key: 'dividendOptionsCashPaymentMethodAccountNo',
            changedValue: [data.dividendOptionsCashPaymentMethodAccountNo],
            originalValue: [data.dividendOptionsCashPaymentMethodAccountNoOld],
          });
          changeList.push({
            key: 'dividendOptionsCashPaymentMethodHolderName',
            changedValue: [data.dividendOptionsCashPaymentMethodHolderName],
            originalValue: [data.dividendOptionsCashPaymentMethodHolderNameOld],
          });
        }
      }
    } else {
      if (data.dividendOptions != data.dividendOptionsOld) {
        changeList.push({
          key: 'dividendOptions',
          changedValue: [data.dividendOptions],
          originalValue: [data.dividendOptionsOld],
        });
      }
    }

    // if (data.paymentOptions == 'Cash Payment') {
    if (data.paymentOptionsCode == 'CASHPAYS') {
      if (data.paymentOptionsCashPaymentMethodCode == 'CQ') {
        if (
          data.paymentOptions != data.paymentOptionsOld ||
          data.paymentOptionsCashPaymentMethod != data.paymentOptionsCashPaymentMethodOld ||
          data.paymentOptionsCashPaymentMethodCheque != data.paymentOptionsCashPaymentMethodChequeOld
        ) {
          changeList.push({
            key: 'paymentOptions',
            changedValue: [data.paymentOptions],
            originalValue: [data.paymentOptionsOld],
          });
          changeList.push({
            key: 'paymentOptionsCashPaymentMethod',
            changedValue: [data.paymentOptionsCashPaymentMethod],
            originalValue: [data.paymentOptionsCashPaymentMethodOld],
          });

          changeList.push({
            key: 'paymentOptionsCashPaymentMethodCheque',
            changedValue: [data.paymentOptionsCashPaymentMethodCheque],
            originalValue: [data.paymentOptionsCashPaymentMethodChequeOld],
          });
        }
        //只有兩個值所以直接else
      } else {
        if (
          data.paymentOptions != data.paymentOptionsOld ||
          data.paymentOptionsCashPaymentMethod != data.paymentOptionsCashPaymentMethodOld ||
          data.paymentOptionsCashPaymentMethodBankCode != data.paymentOptionsCashPaymentMethodBankCodeOld ||
          data.paymentOptionsCashPaymentMethodBranchNo != data.paymentOptionsCashPaymentMethodBranchNoOld ||
          data.paymentOptionsCashPaymentMethodAccountNo != data.paymentOptionsCashPaymentMethodAccountNoOld ||
          data.paymentOptionsCashPaymentMethodHolderName != data.paymentOptionsCashPaymentMethodHolderNameOld
        ) {
          changeList.push({
            key: 'paymentOptions',
            changedValue: [data.paymentOptions],
            originalValue: [data.paymentOptionsOld],
          });
          changeList.push({
            key: 'paymentOptionsCashPaymentMethod',
            changedValue: [data.paymentOptionsCashPaymentMethod],
            originalValue: [data.paymentOptionsCashPaymentMethodOld],
          });
          changeList.push({
            key: 'paymentOptionsCashPaymentMethodBankCode',
            changedValue: [
              data.paymentOptionsCashPaymentMethodBankCode +
                '-' +
                myBankList?.find((item) => item.value === data.paymentOptionsCashPaymentMethodBankCode)?.description,
            ],
            originalValue: [data.paymentOptionsCashPaymentMethodBankCodeOld],
          });
          changeList.push({
            key: 'paymentOptionsCashPaymentMethodBranchNo',
            changedValue: [data.paymentOptionsCashPaymentMethodBranchNo],
            originalValue: [data.paymentOptionsCashPaymentMethodBranchNoOld],
          });
          changeList.push({
            key: paANo,
            changedValue: [data.paymentOptionsCashPaymentMethodAccountNo],
            originalValue: [data.paymentOptionsCashPaymentMethodAccountNoOld],
          });
          changeList.push({
            key: 'paymentOptionsCashPaymentMethodHolderName',
            changedValue: [data.paymentOptionsCashPaymentMethodHolderName],
            originalValue: [data.paymentOptionsCashPaymentMethodHolderNameOld],
          });
        }
      }
    } else {
      if (data.paymentOptions != data.paymentOptionsOld) {
        changeList.push({
          key: 'paymentOptions',
          changedValue: [data.paymentOptions],
          originalValue: [data.paymentOptionsOld],
        });
      }
    }
    return changeList;
  };

  const requestData2 = {
    fieldChanges: isChangeList(form.getFieldsValue(true)) as FieldChange[],
    changeType: '03',
    uploadFlag: false,
    companyCode: companyCode,
    policyNo: policyNumber,
  };
  const [attachments, setAttachments] = useState<Attachments>();
  const ConfrimClick = (values: PolicyOptionsFormData) => {
    console.log('ConfrimClick', values);
    setAttachments(values.attachments);
    if (values) {
      if (filesFlag) {
        if (values.attachments && values.attachments.fileList.length > 0) {
          navigate('/PolicyOptionsOtpVerificationPage', {
            replace: true,
            state: {
              requestData2: requestData2,
              policyNumber: policyNumber,
              attachments: attachments,
              documents: values.attachments,
            },
          });
        }
      } else {
        navigate('/PolicyOptionsOtpVerificationPage', {
          replace: true,
          state: {
            requestData2: requestData2,
            policyNumber: policyNumber,
            attachments: attachments,
          },
        });
      }
    }
  };
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [Message, setMessage] = useState<string>('');

  const {
    data: validateMessage,
    error: validateError,
    shouldFetch: shouldValidateFetch,
  } = useRequestValidate('request-validate', token || '', requestData2);
  useEffect(() => {
    if (validateMessage?.success) {
      shouldValidateFetch(false);
      setaftersub(true);
      setErrorMessage('');
    }
  }, [validateMessage, shouldValidateFetch, errorMessage]);
  useEffect(() => {
    if (validateError && validateError?.code) {
      shouldValidateFetch(false);
      console.log('validateError', validateError.code);
      setErrorMessage(validateError.code);
      setMessage(validateError.message);
    }
  }, [validateError, i18n, shouldValidateFetch]);
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);
  return (
    <EnquiryPageContainer className="ChagepaPage">
      <div style={{ width: '100%' }}>
        <GreetingSection pageName={t('life.policyOptions.paymenttittle')} showicon={false} />
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', top: '-18px', position: 'relative' }}>
          <Select
            onChange={PnChange}
            placeholder={t('life.policyOptions.Pleaseselect')}
            className="policySelect"
            popupClassName="slectop2"
            // defaultValue={policyNo}
            disabled={!policyTypesObject || policyTypesObject.length === 0}
            value={policyNumber ? policyNumber : null}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
              width: '640px',
            }}
          >
            {policyTypesObject &&
              policyTypesObject.map((item) => (
                <Select.Option
                  key={item.value + Math.random()}
                  value={item.value}
                  label2={item.label2}
                  title={item.label2}
                >
                  <div style={{ display: 'grid' }}>
                    <span>{item.label}</span>
                    <span>{item.label2}</span>
                  </div>
                </Select.Option>
              ))}
          </Select>
        </div>
      </div>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="EnquiryContent">
        <Row
          justify="center"
          gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
          style={{ background: '#fff' }}
          className={`centerlist`}
        >
          {!aftersub && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.policyOptions.Paymenttittle')}
                  </div>
                  {!EditCode && policyNumber !== '' && !EditDisable && (
                    <button
                      style={{ padding: '10px 0 0 0', background: 'transparent', border: 'none', cursor: 'pointer' }}
                      disabled={startLoading}
                      onClick={Edit}
                    >
                      <img src={edit} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                      <span
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          color: '#C21B17',
                        }}
                      >
                        {t('life.MakeRequest.contact.Edit')}
                      </span>
                    </button>
                  )}
                  {(policyNumber == '' || (EditDisable && policyNumber !== '')) && (
                    <button style={{ padding: '10px 0 0 0', background: 'transparent', border: 'none' }} disabled>
                      <img src={editdisabled} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                      <span
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          color: '#B0B2B3',
                        }}
                      >
                        {t('life.MakeRequest.contact.Edit')}
                      </span>
                    </button>
                  )}
                </div>
                {EditDisable && policyNumber !== '' && (
                  <div>
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto700',
                        color: '#E9673D',
                      }}
                    >
                      {Errmessage}
                    </div>
                  </div>
                )}
              </div>

              {!EditCode && (
                <Form
                  // initialValues={initialValues}
                  layout={'vertical'}
                  requiredMark={false}
                  form={form}
                  disabled={true}
                  validateTrigger={'onBlur'}
                  className="form"

                  //   isLoading={isLoading}
                >
                  {startLoading && <Spinner />}
                  {policyNumber == '' && <PaymenttactCardno policyTypesObject={policyTypesObject} />}
                  {policyNumber != '' && (
                    <PolicyOptionsCard
                      dividendOptionsList={dividendOptionsList}
                      paymentOptionsList={paymentOptionsList}
                      paymentMethodList={paymentMethodList}
                      annPaymentMethodList={annPaymentMethodList}
                      chequeList={chequeList}
                      divPMName={divPMName}
                      payPMName={payPMName}
                      diviName={diviName}
                      payName={payName}
                    />
                  )}
                </Form>
              )}
              {EditCode && (
                <Form
                  // initialValues={initialValues}
                  layout={'vertical'}
                  requiredMark={false}
                  form={form}
                  onFinish={onSubmit}
                  onFinishFailed={({ values, errorFields, outOfDate }) => {
                    console.log(values, outOfDate, errorFields);
                  }}
                  validateTrigger={'submit'}
                  className="form"
                  preserve={true}
                  scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
                  //   isLoading={isLoading}
                >
                  {startLoading && <Spinner />}
                  <ChangePolicyOptionsCard
                    myBankList={myBankList}
                    //不一定有用------
                    errorMessage={errorMessage}
                    companyCode={companyCode}
                    Message={Message}
                    //-----------------
                    dividendOptionsList={dividendOptionsList}
                    paymentOptionsList={paymentOptionsList}
                    chequeList={chequeList}
                    paymentMethodList={paymentMethodList}
                    annPaymentMethodList={annPaymentMethodList}
                    ref={childRef}
                    divPMName={divPMName}
                    payPMName={payPMName}
                    diviName={diviName}
                    payName={payName}
                  />
                  <AgreementCard2 setIsAgreed={setIsAgreed} />
                  {errorMessage == 'xapi.policy.no.change.request' && (
                    <Alert
                      message={t('life.MakeRequest.hasnochange')}
                      type="error"
                      closable
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  <div className="confrimbutton">
                    <Button
                      // loading={enquirySubmissionIsLoading || isLoading}
                      disabled={!isAgreed}
                      onClick={() => form.submit()}
                      type="primary"
                      className="subbutton"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('life.enquiry.submit')}
                    </Button>
                    <Button
                      // loading={enquirySubmissionIsLoading || isLoading}
                      onClick={() => window.location.reload()}
                      className="cancel"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('life.enquiry.Cancel')}
                    </Button>
                  </div>
                </Form>
              )}
            </Row>
          )}
          {aftersub && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.MakeRequest.ConfirmChanges')}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto700',
                      color: '#E9673D',
                    }}
                  >
                    {t('life.policyOptions.confirmDesc')}
                  </div>
                </div>
              </div>
              <Form
                // initialValues={initialValues}
                layout={'vertical'}
                requiredMark={false}
                form={form}
                className="form"
                onFinish={ConfrimClick}
                //   isLoading={isLoading}
              >
                {startLoading && <Spinner />}
                <PaymentConfrimCard
                  fieldChanges={isChangeList(form.getFieldsValue(true)) as FieldChange[]}
                  myBankList={myBankList}
                  dividendOptionsList={dividendOptionsList}
                  paymentOptionsList={paymentOptionsList}
                  chequeList={chequeList}
                  paymentMethodList={paymentMethodList}
                  annPaymentMethodList={annPaymentMethodList}
                  // diviAccountNo={diviAccountNo}
                  // paymentAccountNo={paymentAccountNo}
                />
                {filesFlag && <DocumentsCard setInvalid={setDocumentInvalid} />}
                <div className="confrimbutton">
                  <Button
                    disabled={filesFlag ? documentInvalid : false}
                    onClick={() => form.submit()}
                    type="primary"
                    className="subbutton"
                    style={{ cursor: 'pointer' }}
                  >
                    {t('life.MakeRequest.contact.Confirm')}
                  </Button>
                  <Button
                    onClick={() => (setaftersub(false), setIsAgreed(false))}
                    className="cancel"
                    style={{ cursor: 'pointer' }}
                  >
                    {t('life.MakeRequest.contact.Back')}
                  </Button>
                </div>
              </Form>
            </Row>
          )}
        </Row>
      </Row>
    </EnquiryPageContainer>
  );
}

export default ChangePolicyOptions;
